// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3PSqj","tab":"ProcedureTabs_tab__1iNoS"};